<template>
  <div class="customer-modulr-form-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i>Edit customer</span>
        
      </div>
      <el-form
      v-if="companyForm"
        :model="companyForm"
        id="companyForm"
        ref="companyForm"
        label-width="180px"
        size="small"
        :rules="companyRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">
     
          <el-col>
            <el-divider content-position="left">Status</el-divider>

            <el-col :xs="24" :sm="24" :md="12" :lg="12" style="padding:0">
            <el-form-item label="Status">
              <el-select
                v-model="companyForm.status"
                placeholder="please select status"
              >
                <el-option label="Active" value="active"></el-option>
                <el-option label="Disable" value="disable"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-checkbox v-model="companyForm.riskBusiness">Risk Business</el-checkbox>
            </el-form-item>
            </el-col>
          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="12">

            <el-card class="card card-director-form" shadow="never">
              <div slot="header" class="clearfix">
                <span>KYC Company</span>
              </div>
              <div>
            <el-form-item
              prop="kyc.company.name"
              label="Company Name"
              :rules="companyRules.company.name"
            >
              <el-input v-model="companyForm.kyc.company.name"></el-input>
            </el-form-item>

            <el-form-item
              prop="kyc.company.typeOfBusiness"
              label="Type Of Business"
              :rules="companyRules.company.typeOfBusiness"
            >
              <!-- <el-input v-model="companyForm.company.typeOfBusiness"></el-input> -->
              <el-select
                v-model="companyForm.kyc.company.typeOfBusiness"
                placeholder="Select type of business"
                
              >
                <el-option
                  v-for="item in typeOfBusinessList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            
            <el-form-item
              prop="kyc.company.registrationNumber"
              label="Registration Number"
              :rules="companyRules.company.registrationNumber"
            >
              <el-input
                v-model="companyForm.kyc.company.registrationNumber"
              ></el-input>
            </el-form-item>

            <el-form-item 
              prop="kyc.company.industryCode" 
              label="Industry Code"
              :rules="companyRules.company.industryCode"
            >
              <el-select
                v-model="companyForm.kyc.company.industryCode"
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword industry"
                :remote-method="searchIndustrial"
                :loading="loading"
                style="width:100%"
              >
                <el-option
                  v-for="item in industryOptions"
                  :key="item.code"
                  :label="`${item.code} : ${item.detail}`"
                  :value="item.section"
                  
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item
              prop="kyc.company.expectedMonthlySpend"
              label="Expected Monthly Spend"
              :rules="companyRules.company.expectedMonthlySpend"
            >
              <el-input type="number"
                v-model="companyForm.kyc.company.expectedMonthlySpend"
              ></el-input>
            </el-form-item>

            <el-form-item prop="kyc.company.addressnumber" label="Address number" :rules="companyRules.company.addressnumber">
              <el-input v-model="companyForm.kyc.company.addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="kyc.company.street" label="Street" :rules="companyRules.company.street">
              <el-input v-model="companyForm.kyc.company.street"></el-input>
            </el-form-item>

            <el-form-item prop="kyc.company.city" label="City" :rules="companyRules.company.city">
              <el-input v-model="companyForm.kyc.company.city"></el-input>
            </el-form-item>

            <el-form-item prop="kyc.company.zipcode" label="Zipcode" :rules="companyRules.company.zipcode">
              <el-input v-model="companyForm.kyc.company.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="kyc.company.countrycode" label="Country code" :rules="companyRules.company.countrycode">
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.kyc.company.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCompanyCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>

              </div>
            </el-card>

          </el-col>
          
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(item, index) in companyForm.kyc.associates" :key="index">
            <el-card class="card card-director-form" shadow="never">
              <div slot="header" class="clearfix">
                <span>{{ (item.position && item.position.replace("_", " ")) || 'NEW DIRECTOR'}}</span>
                <div style="float: right; padding: 3px 0">
                  <el-button type="success" icon="el-icon-plus" size="mini" circle @click="addDirector()"></el-button>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle v-if="!item.applicant && ![0, 1].includes(index)" @click="removeDirector(index)"></el-button>
                </div>
              </div>
              <div>
                <el-form-item label="First Name" 
                :prop="`kyc.associates[${index}].firstName`"
                :rules="companyRules.associates.firstName">
                  <el-input v-model="companyForm.kyc.associates[index].firstName"></el-input>
                </el-form-item>

                <el-form-item label="Last Name" 
                  :prop="`kyc.associates[${index}].lastName`"
                  :rules="companyRules.associates.lastName">
                    <el-input v-model="companyForm.kyc.associates[index].lastName"></el-input>
                </el-form-item>

                <el-form-item
                  :prop="`kyc.associates[${index}].position`"
                  label="Position"
                  :rules="companyRules.associates.position"
                >
                  <el-select v-model="companyForm.kyc.associates[index].position" 
                    placeholder="Select Position"
                    :disabled="[0, 1].includes(index)"
                    >
                    <el-option
                      v-for="(item, index) in directorPositionList"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Email" 
                  :prop="`kyc.associates[${index}].email`"
                  :rules="companyRules.associates.email">
                    <el-input v-model="companyForm.kyc.associates[index].email"></el-input>
                </el-form-item>

                <el-form-item label="Date of Birth" 
                  :prop="`kyc.associates[${index}].dateOfBirth`"
                  :rules="companyRules.associates.dateOfBirth">
                    <!-- <el-input v-model="companyForm.associates[index].dateOfBirth"></el-input> -->
                    <el-date-picker
                      v-model="companyForm.kyc.associates[index].dateOfBirth"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="Choose date of birth">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="Telephone" 
                  :prop="`kyc.associates[${index}].telephone`"
                  :rules="companyRules.associates.telephone">
                    <el-input v-model="companyForm.kyc.associates[index].telephone"></el-input>
                </el-form-item>

                <el-form-item label="Address number" 
                  :prop="`kyc.associates[${index}].addressnumber`"
                  :rules="companyRules.associates.addressnumber">
                    <el-input v-model="companyForm.kyc.associates[index].addressnumber"></el-input>
                </el-form-item>

                <el-form-item label="Street" 
                  :prop="`kyc.associates[${index}].street`"
                  :rules="companyRules.associates.street">
                    <el-input v-model="companyForm.kyc.associates[index].street"></el-input>
                </el-form-item>

                <el-form-item label="City" 
                  :prop="`kyc.associates[${index}].city`"
                  :rules="companyRules.associates.city">
                    <el-input v-model="companyForm.kyc.associates[index].city"></el-input>
                </el-form-item>

                <el-form-item label="Country Code" 
                  :prop="`kyc.associates[${index}].countrycode`" 
                  :rules="companyRules.associates.countrycode">
                    <!-- <el-input v-model="companyForm.associates[index].countrycode"></el-input> -->
                    <el-autocomplete
                      class="inline-input"
                      v-model="companyForm.kyc.associates[index].countrycode"
                      :fetch-suggestions="querySearchCountrycode"
                      @select="selectDirectorCountrycode($event, index)"
                      :maxlength="2"
                    >
                      <template slot-scope="{ item }">
                        <div>{{ item.country_code }} - {{ item.country_name }}</div>
                      </template>
                    </el-autocomplete>
                </el-form-item>

                <el-form-item label="Zipcode" 
                  :prop="`kyc.associates[${index}].zipcode`"
                  :rules="companyRules.associates.zipcode">
                    <el-input v-model="companyForm.kyc.associates[index].zipcode"></el-input>
                </el-form-item>

                <el-form-item label="Ownership" 
                  :prop="`kyc.associates[${index}].ownership`"
                  :rules="companyRules.associates.ownership"
                  v-if="companyForm.kyc.associates[index].position == 'BENE_OWNER'"
                  >
                    <el-input type="number" v-model="companyForm.kyc.associates[index].ownership">
                      <template slot="append">%</template>
                    </el-input>
                </el-form-item>
              </div>
            </el-card>


          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center">
        <el-button type="primary" :loading="submiting" @click="submitCustomer()"
          >Submit</el-button
        >
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import model from "@/views/company/models/vender-modulr-model.js";
import { mapGetters } from "vuex";
import { getUtility, updateCustomer } from "@/api/customer";
import { getIndustrialCodes } from "@/api/utility";
export default {
  props: {
    formData: Object
  },
  computed: {
    ...mapGetters(["user_project"]),
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      loading: false,
      submiting: false,
      dialogShow: false,
      errMsg: "",
      utility: {},
      industryOptions: [],
      companyForm: this.formData,
      companyRules: model.getCompanyRulesForm(),
      typeOfBusinessList: model.getTypeOfBusinessList(),
      directorPositionList: model.getDirectorPositionList(),
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    cancelForm() {
      if(this.$route.query.ref && this.$route.query.ref == 'customer'){
        this.$router.push(`/project/${this.user_project}?tab=customer`);
      }else if( this.$route.query.ref && this.$route.query.ref == 'info'){
        this.$router.push(`/customer/view/${this.user_project}/${this.companyForm.enduser_id}`);
      }else{
        this.$router.push('/customer')
      }
      
    },
    addDirector(){
      this.companyForm.kyc.associates.push({
        applicant: false,
        dateOfBirth: "",
        email: "",
        firstName: "",
        lastName: "",
        position: "",
        telephone: "",
        addressnumber: "",
        street: "",
        city: "",
        countrycode: "",
        zipcode: "",
        ownership: 0
      });
    },
    removeDirector(index){
      this.companyForm.kyc.associates.splice(index, 1);
    },
    getFormData() {
      let formData = JSON.parse(JSON.stringify(this.companyForm));
      formData.name = formData.kyc.company.name
      formData.kyc.company.riskBusiness = formData.riskBusiness;
      delete formData.riskBusiness;
      return formData;
    },
    updateCustomer() {
      let formData = this.getFormData();
      this.submiting = true;
      this.errMsg = "";
      updateCustomer(formData.enduser_id, formData).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Customer successfully`,
              type: "success",
              duration: 2000
            });
            this.cancelForm()
            this.$emit("on-submited", true);
          } else {
            this.errMsg =
              typeof message === "string" ? message : "Update Customer Error";
          }
        }
      );
    },
    submitCustomer() {
     //this.$emit("on-submited", true);
        this.$refs.companyForm.validate((valid) => {
          if (valid) {
            this.updateCustomer();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      
    },
    resetForm() {
      if (this.$refs.companyForm) this.$refs.companyForm.resetFields();
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_code})
      // })
      cb(results);
    },
   
  

    searchIndustrial(queryString) {
      this.loading = true;
      getIndustrialCodes(queryString).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.industryOptions = data;
        }
      });
    },

    selectDirectorCountrycode(item, index) {
      this.companyForm.kyc.associates[index].countrycode = item.country_code;
    },
    selectCompanyCountrycode(item) {
      this.companyForm.kyc.company.countrycode = item.country_code;
    },
  
    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },

  },
  mounted() {
    this.getUtility();
  },
};
</script>

<style lang="scss">
.customer-modulr-form-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }
  .card-director-form{
    margin-bottom: 10px;
  }

  .footer{
    border-top: 1px solid #ebeef5;
    padding-top: 20px;
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
  }

}
</style>